import { createContext, useContext } from 'react';

interface AuthContextInterface {
  openLogin: boolean;
  setOpenLogin: (val: boolean) => void;
}

/**
 * AuthContext
 */
export const AuthContext = createContext<AuthContextInterface>({
  openLogin: false,
  setOpenLogin: (val) => {},
});

export const useAuthContext = () => useContext(AuthContext);
